$(document).ready(function() {
  $('div.scrolltop').hide();
  $(window).scroll(function(){
    var value = 200;
    var scrolling = $(window).scrollTop();
    if (scrolling > value) {
      $('div.scrolltop').fadeIn();
    } else {
      $('div.scrolltop').fadeOut();
    }
  });
  $('div.scrolltop').click(function(){
    $('html, body').animate({scrollTop:'0px'}, 1000);
    return false;
  });
  
        if ($(this).scrollTop() > 0 && $(document).width() >= 992) {
        	if (!$(".bangb1").hasClass("fixedTop"))
            	$(".bangb1").addClass("fixedTop").hide().fadeIn(400);
        } else {
            $(".bangb1").show().removeClass("fixedTop");
        }
});

    $(window).scroll(function() {
    	        //if ($(this).scrollTop() == 120) 
    	        //	$(".bangb1").hide();
        if ($(this).scrollTop() > 90 && $(document).width() >= 992) {
        	if (!$(".bangb1").hasClass("fixedTop"))
            	$(".bangb1").addClass("fixedTop").hide().fadeIn(400);
        } else {
            $(".bangb1").show().removeClass("fixedTop");
        }
    });


$(function() {
    $('.page-scroll a').bind('click', function(event) {
        var $anchor = $(this);
        $('html, body').stop().animate({
            scrollTop: $($anchor.attr('href')).offset().top
        }, 1500, 'linear');
        event.preventDefault();
    });
});
